import restAction from "@/js/store/module/common/restAction";

/* 사용자 사진 LRU 캐시 최대 크기 */
const HW_PHOTO_CACHE_SIZE = 200;
/* 사용자 사진 Download 큐 */
const HW_PHOTO_WORK_QUEUE = [];
/* image Load 큐 */
const HW_IMAGE_WORK_QUEUE = [];
/* 사용자 사진 캐시 */
const HW_USER_PHOTO_CACHE = [[], {}];
/* IE 체크 */
let IE_VER = false;

const state = {
  userPhotoQueue: HW_PHOTO_WORK_QUEUE,
  userPhotoCache: HW_USER_PHOTO_CACHE,
  imageLoadQueue: HW_IMAGE_WORK_QUEUE
};

const IMAGE_REQUEST = function(uid, imageURI, img, callback, fncClose) {
  let xhr = new XMLHttpRequest();
  xhr.onreadystatechange = () => {
    let readyState = xhr.readyState;
    let status = xhr.status;
    if (readyState == XMLHttpRequest.DONE) {
      // console.log("STATE:" + readyState + " " + status);
      if (status == 200) {
        // console.log("RESPONSE:", xhr.response);
        if (xhr.response.type != "application/json" && xhr.response.size > 100) {
          let blob = URL.createObjectURL(xhr.response);
          if (blob) {
            if (img) { img.src = blob; }
            if (callback) { callback(blob); }
          }
        }
        else {
          console.log("Image may not be loaded ", imageURI);
        }
      }
      // console.log("NEXT!!");
      fncClose(uid);
    }
  };
  xhr.onerror = () => { fncClose(uid, "ERROR-1"); };
  xhr.ontimeout = () => { fncClose(uid, "TIMEOUT"); };
  xhr.addEventListener("load", () => {
    if (xhr.status < 400) { /* OK */ }
    else if (xhr.status == 500) { fncClose(uid, "500"); }
    else { fncClose(uid, "ERROR-2"); }
  });
  xhr.addEventListener("error", () => { fncClose(uid, "ERROR-3"); });
  xhr.open("GET", imageURI, true);
  let token = localStorage.getItem("Authorization");
  xhr.setRequestHeader("Authorization", token);
  xhr.responseType = "blob";
  try { xhr.send(); } catch (e) { fncClose(uid, "ERROR-4"); }
};

const PHOTO_REQUEST = function(uid, userId, img, callback, fncClose) {
  let cache = state.userPhotoCache;
  let lruqueue = cache[0];
  let photoMap = cache[1];
  if (!photoMap[userId]) {
    let fncError = (uid, error) => {
      photoMap[userId] = { blob: 1 };
      fncClose(uid, error)
    };
    photoMap[userId] = { };
    let photo = photoMap[userId];
    lruqueue.splice(0, 0, userId);
    let imageURI = "/api/org/getUserPhoto?userId=" + userId;
    let xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      let readyState = xhr.readyState;
      let status = xhr.status;
      if (readyState == XMLHttpRequest.DONE) {
        // console.log("STATE:" + readyState + " " + status);
        if (status == 200) {
          // console.log("RESPONSE:", xhr.response);
          if (xhr.response.type != "application/json" && xhr.response.size > 100) {
            photo.blob = URL.createObjectURL(xhr.response);
            if (photo.blob) {
              if (img) { img.src = photo.blob; }
              if (callback) { callback(photo.blob); }
            }
          }
          else {
            console.log("Photo may not be loaded ", userId);
          }
        }
        // console.log("NEXT!!");
        fncClose(uid);
      }
    };
    xhr.onerror = () => { fncError(uid, "ERROR-1"); };
    xhr.ontimeout = () => { fncError(uid, "TIMEOUT"); };
    xhr.addEventListener("load", () => {
      if (xhr.status < 400) { /* OK */ }
      else if (xhr.status == 500) { fncError(uid, "500"); }
      else { fncError(uid, "ERROR-2"); }
    });
    xhr.addEventListener("error", () => { fncError(uid, "ERROR-3"); });
    xhr.open("GET", imageURI, true);
    let token = localStorage.getItem("Authorization");
    xhr.setRequestHeader("Authorization", token);
    xhr.responseType = "blob";
    try { xhr.send(); } catch (e) { fncError(uid, "ERROR-4"); }
    // console.log("LRU SIZE:", lruqueue.length);
    /* lru 사이즈가 200을 넘으면 나머지 삭제 */
    if (lruqueue.length > HW_PHOTO_CACHE_SIZE) {
      for (let cinx = HW_PHOTO_CACHE_SIZE; cinx < lruqueue.length;) {
        let photoId = lruqueue[cinx];
        lruqueue.splice(cinx, 1);
        setTimeout(() => {
          delete photoMap[photoId];
          console.log("TRIM LRU CACHE:", photoId, lruqueue.length);
        }, 1);
      }
    }
  }
  else {
    // console.log("REUSE:" + userId);
    let photo = photoMap[userId];
    if (photo.blob) {
      if (photo.blob != 1) {
        /* 받아온 데이터가 있다면 재사용 */
        if (img) { img.src = photo.blob; }
        if (callback) { callback(photo.blob); }
      }
      // console.log("NEXT!!");
      fncClose(uid);
      let cinx = lruqueue.indexOf(userId);
      if (cinx > 0) {
        lruqueue.splice(cinx, 1);
        lruqueue.splice(0, 0, userId);
      }
    }
    else {
      /* 대기 */
      setTimeout(() => { actions.HW_GET_USER_PHOTO({state}, {img, userId, callback}) }, 100);
    }
  }
};

const COWORK_REST_ACTION = restAction.actions.COWORK_REST_ACTION;

const actions = {
  /* 숫자 앞자릿수 공백을 0 으로 치환 */
  ZERO_PAD({state}, {num, digit, res=[]}) {
    let ret = String(num);
    for (let inx = ret.length; inx < digit; inx++) {
      ret = "0" + ret;
    }
    if (res && Array.isArray(res)) { res[0] = ret; }
    return ret;
  },
  /* 대소문자 영문 난수를 발생 */
  RANDOM_CHRS({state}, {num, res=[]}) {
    let ret = "";
    for (let inx = 0; inx < num; inx++) {
      let rnd = Math.floor(Math.abs(Math.random() * 52));
      let ch = 0x00;
      if (rnd < 26) {
        ch = 0x61 + rnd;
      }
      else {
        ch = 0x041 + (rnd - 26);
      }
      // console.log("RND:" + String.fromCharCode(ch));
      ret += String.fromCharCode(ch);
    }
    if (res && Array.isArray(res)) { res[0] = ret; }
    return ret;
  },
  /* 블럭ID 등 키를 발행하는 메소드 */
  HW_KEYGEN({state}, {head="", res=[]}) {
    let ret = "";
    let tail = "";
    let date = new Date();
    tail = actions.RANDOM_CHRS({state}, {num: 4});
    ret =
      actions.ZERO_PAD({state}, {num: date.getFullYear(),     digit: 4}) +
      actions.ZERO_PAD({state}, {num: date.getMonth() + 1,    digit: 2}) +
      actions.ZERO_PAD({state}, {num: date.getDate(),         digit: 2}) +
      actions.ZERO_PAD({state}, {num: date.getHours(),        digit: 2}) +
      actions.ZERO_PAD({state}, {num: date.getMinutes(),      digit: 2}) +
      actions.ZERO_PAD({state}, {num: date.getSeconds(),      digit: 2}) +
      actions.ZERO_PAD({state}, {num: date.getMilliseconds(), digit: 3});
    ret = head + ret + tail;
    if (res && Array.isArray(res)) { res[0] = ret; }
    return ret;
  },
  HW_GET_USER_PHOTO ({state}, {img, userId, callback = false}) {
    if (userId) {
      let uid = actions.HW_KEYGEN({state}, {head: "PHTR"});
      let workQueue = state.userPhotoQueue;
      let fncNext = () => {
        let work = null;
        while (!work && workQueue.length > 0) {
          work = workQueue[0];
          // console.log("WORK-TYPE:", work.type, document.querySelector("body").contains(work.obj), workQueue.length, HW_USER_PHOTO_CACHE[1]);
          if (work && work.type == 1 && !document.querySelector("body").contains(work.obj)) {
              work = null;
          }
          if (!work) { workQueue.splice(0, 1); }
          if (work) { break; }
        }
        if (work && work.state === 0) {
          // console.log("START:" + work.uid);
          work.state = 1;
          setTimeout(work.fnc, 1);
        }
        /* 아래주석을 풀게되면 모든 사진이 동시에 불려짐(트래픽 병목 유발) */
        // else {
        //   workQueue.splice(0, 1);
        //   setTimeout(fncNext, 1);
        // }
      };
      let fncClose = (uid, error = false) => {
        if (error) { console.log("ERROR:", error); }
        for (let inx = 0; inx < workQueue.length; inx++) {
          let work = workQueue[inx];
          if (work.uid === uid) {
            if (error) {
              console.log("ERROR:", work.uid, work.userId);
            }
            workQueue.splice(inx, 1);
            // console.log("FINISH:", work.uid, workQueue.length);
            break;
          }
        }
        // console.log("IMG LOADED! QUEUE:" + workQueue.length);
        fncNext();
      };
      // console.log("IMG:", uid, (img ? 1 : 0), img);
      workQueue.push({ uid: uid, fnc: () => { PHOTO_REQUEST(uid, userId, img, callback, fncClose); },
        state: 0, type: img ? 1 : 0, obj: img, userId: userId });
      fncNext();
    }
  },
  HW_LOAD_IMAGE ({state}, {img, groupId, paperId, fileId, callback = false}) {
    let uid = actions.HW_KEYGEN({state}, {head: "IMGR"});
    let workQueue = state.imageLoadQueue;
    let fncNext = () => {
      let work = null;
      while (!work && workQueue.length > 0) {
        work = workQueue[0];
        if (work && work.type == 1 && !document.querySelector("body").contains(work.obj)) {
            work = null;
        }
        if (!work) { workQueue.splice(0, 1); }
        if (work) { break; }
      }
      if (work && work.state === 0) {
        work.state = 1;
        setTimeout(work.fnc, 1);
      }
    };
    let fncClose = (uid, error = false) => {
      // 이미지 로드에 실패했어도 블럭카운트를 맞추기위해 callback 호출.
      if (error) { console.log("ERROR:", error); callback(false); }
      for (let inx = 0; inx < workQueue.length; inx++) {
        let work = workQueue[inx];
        if (work.uid === uid) {
          if (error) {
            console.log("ERROR:", work.uid, work.fileId);
          }
          workQueue.splice(inx, 1);
          break;
        }
      }
      fncNext();
    };

    let imageURI =
      "/api/cofile/paper/imageViewer?groupId=" + groupId + 
      "&paperId=" + paperId + "&fileId=" + fileId;

    workQueue.push({ uid: uid, fnc: () => { IMAGE_REQUEST(uid, imageURI, img, callback, fncClose); },
      state: 0, type: img ? 1 : 0, obj: img, fileId: fileId });
    fncNext();
  },
  /* 특정 함수를 조건이 될때까지 기다렸다가 수행하는 메소드 */
  CHECK_AND_LAUNCH({state}, {check, launch, interval}) {
    if (!interval) {
      interval = 100;
    }
    let ctx = {
      __max_test: 100,
      __interval: interval
    };
    let fnc = function() {
      if (check(ctx)) {
        launch(ctx);
      }
      else if (ctx.__max_test > 0) {
        ctx.__max_test--;
        setTimeout(fnc, ctx.__interval);
      }
    };
    setTimeout(fnc, ctx.__interval);
  },
  /* IE에서 날자 Picker 커서 숨김 편법 */
  HIDE_CURSOR_DATEPICKER({state}, {self}) {
    actions.CHECK_AND_LAUNCH({state}, {
      check(ctx) { return (ctx.ret = self.$el.querySelectorAll(".vdp-datepicker input[readonly]")).length > 0; },
      launch(ctx) {
        for (let elem of ctx.ret) {
          if (!elem.getAttribute("data-onfocus")) {
            let fnc = () => {
              elem.focus(); elem.setSelectionRange(0, 0);
            };
            let calendar = elem.parentNode.parentNode.querySelector(".vdp-datepicker__calendar");
            elem.onclick = fnc;
            new MutationObserver(fnc).observe(calendar, { attributes: true });
            elem.style.textIndent = "-1px";
            elem.setAttribute("data-onfocus", "1");
          }
        }
      }
    });
  },
  CHECK_IE({state}, {res=[]}) {
    if (IE_VER) {
      if (IE_VER === 1) {
        res[0] = true;
        return true;
      }
      else if (IE_VER === 2) {
        res[0] = false;
        return false;
      }
    }
    else {
      let ua = window.navigator.userAgent;
      let msie = ua.indexOf("MSIE ");
      if (msie > 0 || !!ua.match(/Trident.*rv\:11\./)) {
        IE_VER = 1;
        res[0] = true;
        return true;
      }
      IE_VER = 2;
      res[0] = false;
      return false;
    }
  },
  COPY_ELEMENT({}, {from, to, res=[]}) {
    for(let inx = 0, attrs = from.attributes; inx < attrs.length; inx++) {
      let key = attrs[inx].name;
      to.setAttribute(key, from.getAttribute(key));
    }
    to.innerHTML = from.innerHTML;
    res[0] = to;
    return to;
  },
  HAS_SUB({state}, {obj, keys, res=[]}) {
    if (!obj) { return false; }
    if (!keys || keys.length == 0 || !(keys instanceof Array)) {
      res[0] = obj;
      return obj;
    }
    let target = obj;

    for (let inx = 0; inx < keys.length; inx++) {
      if (!target[keys[inx]]) {
        target = null;
        break;
      }
      target = target[keys[inx]];
    }
    res[0] = target;
    return target;
  },
  IMG_TO_BLOB ({state}, {img, blobProc, b64Proc}) {
    let xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
        if (xhr.response.type != "application/json" && xhr.response.size > 100) {
          if (blobProc) {
            blobProc(xhr.response);
          }
          if (b64Proc) {
            let reader = new FileReader();
            reader.readAsDataURL(xhr.response);
            reader.onload = () => { b64Proc(reader.result); };
          }
        }
      }
    };
    xhr.open("GET", img.src, true);
    xhr.responseType = "blob";
    xhr.send();
  },
  B642BLOB ({}, {b64data, size = 512, buffer = []}) {
    const byteCharacters = atob(b64data);
    for (let offset = 0; offset < byteCharacters.length; offset += size) {
      const slice = byteCharacters.slice(offset, offset + size);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      buffer.push(byteArray);
    }
    // const blob = new Blob(buffer, {type: contentType});
    // return blob;
  },
  ERR_REPORT({}, {from = "", err = ""}) {
      COWORK_REST_ACTION({}, {
        url: "/api/copaper/paper/errReport",
        method: "post",
        req: { from: from, err: err }
      }).then((res) => { });
  }
};
const mutations = {};
const getters = {};
export default { state, actions, mutations, getters, namespaced: true };


// WEBPACK FOOTER //
// ./src/js/store/module/common/coworkUtils.js